import React from "react";
import { CvDownloadButton, CvLink } from "../NavBar/StyledNavBar";
import {
  CloseIcon,
  Icon,
  SidbarContainer,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SideBtnWrap,
} from "./StyledSidebar";
import myResume from "./resume.pdf";

function Sidebar({ isOpen, toggle }) {
  return (
    <SidbarContainer isOpen={isOpen} toggle={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to="about" onClick={toggle}>
            About
          </SidebarLink>
          <SidebarLink to="skills" onClick={toggle}>
            Skills
          </SidebarLink>
          <SidebarLink to="projects" onClick={toggle}>
            My Projects
          </SidebarLink>
          <SidebarLink to="contact-me" onClick={toggle}>
            Contact Me
          </SidebarLink>
        </SidebarMenu>
        <SideBtnWrap>
          <CvLink href={myResume} download="AviMizrahiCV">
            <CvDownloadButton>Download Resume</CvDownloadButton>
          </CvLink>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidbarContainer>
  );
}

export default Sidebar;
